import { createSlice } from '@reduxjs/toolkit'
import { Dayjs } from 'dayjs'

export type InsuranceInfoWithConcentDate = {
  consentDate: Dayjs;
};

export type InsuranceInfoWithoutConcentDate = {
  id?: number;
  name: string;
  amountReceipt: number;
  amountClaim: number;
  receiptFile: string;
  optionalFileUrl: string;
  relativeTypeId: string;
  receiptDate: string;
  claimName: string;
  receiptNo: string;
  remark?: string;
};

export type InsuranceInf = {
  InsuranceInfo: InsuranceInfoWithConcentDate | InsuranceInfoWithoutConcentDate;
}

export const initState: InsuranceInf = {
  InsuranceInfo: {
    name: '',
    amountReceipt: 0,
    amountClaim: 0,
    receiptFile: '',
    optionalFileUrl: '',
    relativeTypeId: '',
    receiptDate: '',
    claimName: '',
    receiptNo: '',
    remark: '',
  },
}

const InsuranceSlice = createSlice({
  name: 'insurance',
  initialState: initState,
  reducers: {
    setInsuranceInfo: (
      state,
      { payload }: PayloadWithType<InsuranceInf['InsuranceInfo']>
    ) => {
      state.InsuranceInfo = payload
    },
    clearInsuranceInfo: (state) => {
      state.InsuranceInfo = initState.InsuranceInfo
    },
  },
})

export const insuranceReducer = InsuranceSlice.reducer
export const { setInsuranceInfo, clearInsuranceInfo } = InsuranceSlice.actions
